var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { connect } from 'react-redux';
import { scoreSystemNames } from '@crimp/lib-score-systems';
import getAppButtons from '@crimp/lib-score-systems/dist/getAppButtons';
import { feathersServices } from 'src/feathers';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import FormScoreString from './FormScoreString';
import SpinnerCrimp from 'src/pages/components/utilities/SpinnerCrimp';
var formStyles = require('src/imports/styles/extend.form.scss');
var selfStyles = require('./styles.scss');
var FormAthleteScoreRouteHistory = (function (_super) {
    __extends(FormAthleteScoreRouteHistory, _super);
    function FormAthleteScoreRouteHistory(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFetching: true,
        };
        _this.handlePatchAthleteScoreRouteHistory = _this.handlePatchAthleteScoreRouteHistory.bind(_this);
        return _this;
    }
    FormAthleteScoreRouteHistory.prototype.componentDidMount = function () {
        if (this.props.scoreboard.athleteId && this.props.scoreboard.athleteScoreRouteId) {
            this.hydrateAthleteScoreRouteHistory(this.props.scoreboard.athleteId, this.props.scoreboard.athleteScoreRouteId);
        }
        else {
            this.setState({ isFetching: false });
        }
    };
    FormAthleteScoreRouteHistory.prototype.componentWillReceiveProps = function (nextProps) {
        if (!nextProps.scoreboard.athleteId || !nextProps.scoreboard.athleteScoreRouteId) {
            return;
        }
        if (nextProps.scoreboard.athleteId !== this.props.scoreboard.athleteId ||
            nextProps.scoreboard.athleteScoreRouteId !== this.props.scoreboard.athleteScoreRouteId) {
            this.hydrateAthleteScoreRouteHistory(nextProps.scoreboard.athleteId, nextProps.scoreboard.athleteScoreRouteId);
        }
    };
    FormAthleteScoreRouteHistory.prototype.hydrateAthleteScoreRouteHistory = function (athleteId, athleteScoreRouteId) {
        return __awaiter(this, void 0, void 0, function () {
            var athleteScoreRouteHistoryReponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isFetching: true });
                        return [4, this.handleFindAthleteScoreRouteHistory(athleteScoreRouteId)];
                    case 1:
                        athleteScoreRouteHistoryReponse = _a.sent();
                        if (athleteScoreRouteHistoryReponse.value.total === 0) {
                            this.setState({
                                isFetching: false,
                                athleteScoreRouteHistory: undefined,
                                newScoreString: undefined,
                            });
                        }
                        else {
                            this.setState({
                                isFetching: false,
                                athleteScoreRouteHistory: athleteScoreRouteHistoryReponse.value.data[0],
                                newScoreString: athleteScoreRouteHistoryReponse.value.data[0].scoreString,
                            });
                        }
                        return [2];
                }
            });
        });
    };
    FormAthleteScoreRouteHistory.prototype.handleFindAthleteScoreRouteHistory = function (athleteScoreRouteId) {
        return this.props.dispatch(feathersServices.athleteScoreRouteHistories.find({
            query: {
                athleteScoreRouteId: athleteScoreRouteId,
                $limit: 1,
            },
        }));
    };
    FormAthleteScoreRouteHistory.prototype.handlePatchAthleteScoreRouteHistory = function (aSRH) {
        return this.props.dispatch(feathersServices.athleteScoreRouteHistories.patch(aSRH.id, aSRH));
    };
    FormAthleteScoreRouteHistory.prototype.render = function () {
        if (this.state.isFetching) {
            return (React.createElement("div", { className: selfStyles.formSpinnerWrapper },
                React.createElement(SpinnerCrimp, null)));
        }
        var athleteScoreRouteHistory = this.state.athleteScoreRouteHistory;
        if (!this.props.scoreboard.athleteScoreRouteId || !athleteScoreRouteHistory) {
            return (React.createElement("div", { className: selfStyles.formSpinnerWrapper },
                React.createElement("p", null, "Please click on a route to see its score")));
        }
        var round = this.props.workspaceEvent.round;
        var route = this.props.workspaceEvent.routes && this.props.workspaceEvent.routes.find(function (r) { return r.id === athleteScoreRouteHistory.routeId; });
        if (!round || !route) {
            return (React.createElement("div", { className: selfStyles.formSpinnerWrapper },
                React.createElement("p", null, "Error encountered: Please refresh the page.")));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: formStyles.header + " " + selfStyles.cardHeader },
                "Route: ",
                round && round.code,
                route && route.index + 1),
            React.createElement("span", null,
                "Format: ",
                React.createElement("strong", null, scoreSystemNames[round.scoreSystem])),
            React.createElement("br", null),
            React.createElement("span", null, "Valid raw score values:"),
            React.createElement("ul", null,
                (getAppButtons(round.scoreSystem) || []).map(function (a) { return React.createElement("li", { key: a.value },
                    React.createElement("strong", null, a.value),
                    ": ",
                    a.hint); }),
                React.createElement("li", null,
                    React.createElement("strong", null, "X"),
                    ": Void score for athlete on the route")),
            React.createElement(Divider, null),
            React.createElement(FormScoreString, { userProfile: this.props.workspaceMain.userProfile, athleteScoreRouteHistory: athleteScoreRouteHistory, handlePatchAthleteScoreRouteHistory: this.handlePatchAthleteScoreRouteHistory })));
    };
    return FormAthleteScoreRouteHistory;
}(React.Component));
var mapStateToProps = function (state) {
    var roundId = state.scoreboard.roundId;
    return {
        workspaceMain: {
            userProfile: state.workspaceMain.userProfile && state.workspaceMain.userProfile.data[0],
        },
        workspaceEvent: {
            round: state.workspaceEvent.rounds && state.workspaceEvent.rounds.data.find(function (r) { return r.id === roundId; }),
            routes: state.workspaceEvent.routes && state.workspaceEvent.routes.data.filter(function (r) { return r.roundId === roundId; }),
        },
        scoreboard: state.scoreboard,
    };
};
export default connect(mapStateToProps)(FormAthleteScoreRouteHistory);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormTeamAthleteScore/FormAthleteScoreRouteHistory/index.tsx
// module id = 968
// module chunks = 0